import { MOTION } from 'styles/consts'

export const CONTAINER_ANIMATION_PROPS = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: MOTION.duration.base, ease: MOTION.ease.out }
}

/* Modals enter from a barely-scaled state (0.96) — a full-scale pop reads as
   heavy. Exit is faster than enter. */
export const CONTENT_ANIMATION_PROPS = {
  initial: {
    opacity: 0,
    scale: 0.96,
    translateX: '-50%',
    translateY: '-50%'
  },
  animate: { opacity: 1, scale: 1 },
  exit: {
    opacity: 0,
    scale: 0.98,
    transition: {
      duration: MOTION.duration.fast,
      ease: MOTION.ease.out
    }
  },
  transition: { duration: MOTION.duration.base, ease: MOTION.ease.out }
}
